<template>
  <div class="content-wrapper">
    <router-view :key="this.$route.fullPath"></router-view>
  </div>
</template>

<script>
  export default {
    name: "Content",
  };
</script>

<style lang="scss" scoped>
  .content-wrapper {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
</style>
